// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2nsjy","logo":"styles_logo__3vGpc","description":"styles_description__1v5U5","welcome_text":"styles_welcome_text__64eUK"};